import React, { useState, useEffect } from "react";
import CodeEditor from "./CodeEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./styles.css";
// import mjml2html from "mjml";
import getCode from "./libs/getCode";
import parseHTMLtoJSX from "./libs/parseHTMLtoJSX";
import parseMJMLtoHTML from "./libs/parseMJMLtoHTML";

// import { grid } from "./templates/grid";
import { mj } from "./templates/mjml";

var htmlStarter = mj;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const codepenSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="inline-block h-6 my-auto"
    viewBox="0 0 24 24"
  >
    <path d="M12 2L22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2z"></path>
    <path d="M12 22L12 15.5"></path>
    <path d="M22 8.5L12 15.5 2 8.5"></path>
    <path d="M2 15.5L12 8.5 22 15.5"></path>
    <path d="M12 2L12 8.5"></path>
  </svg>
);

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  boxShadow: isDragging
    ? "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px"
    : "",
  // change background colour if dragging
  // background: isDragging ? "white" : "",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = (isDraggingOver) => ({
  // background: isDraggingOver ? "lightblue" : "#f1f1f1",
  padding: 8,
  width: "100%",
  border: isDraggingOver ? "1px dotted #398dfa" : ""
});

function App(props) {
  const [items, setItems] = useState([]);
  // const [reactComponent, setReactComponent] = useState(null);
  const [htmlInput, setHtmlInput] = useState(htmlStarter);
  const [parsedHTML, setParsedHTML] = useState("");
  const [dragging, setDragging] = useState("");

  const [head, setHead] = useState("");
  const [preheader, setPreheader] = useState("");
  const [bodyAttributes, setBodyAttributes] = useState("");
  const [wrapperAttributes, setWrapperAttributes] = useState("");

  // const mceRefs = useRef([]);

  useEffect(() => {
    parseHTMLInput(htmlInput);
  }, []);

  const submitCodepen = async (e) => {
    e.preventDefault();

    var code = getCode(
      items,
      head,
      bodyAttributes,
      wrapperAttributes,
      preheader
    );

    document.codepen.data.value = JSON.stringify({
      title: "New Letter!",
      html: code.documentElement.innerHTML
    });

    document.codepen.action = "https://codepen.io/pen/define";
    document.codepen.method = "POST";
    document.codepen.target = "_blank";
    document.codepen.submit();
  };

  const parseHTMLInput = async (mjmlCode) => {
    setItems([]);

    var parsedMJML = await parseMJMLtoHTML(mjmlCode);
    if (parsedMJML) {
      setParsedHTML(parsedMJML);
    }
    var codeObject = parseHTMLtoJSX(parsedMJML.htmlDoc);
    // var head = getHead()

    setHead(parsedMJML.head);
    setPreheader(parsedMJML.preheader);
    setWrapperAttributes(parsedMJML.wrapperAttributes);
    setBodyAttributes(parsedMJML.bodyAttributes);

    setItems(codeObject.itemArray);
    // setReactComponent(codeObject.reactComponent);
  };

  const onDragEnd = (result) => {
    // dropped outside the list

    // window.tinymce.activeEditor.setMode("design");
    if (!result.destination) {
      return;
    }

    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(newItems);
    setDragging(false);
  };

  const onDragStart = () => {
    // alert("start");
    if (window.tinymce && window.tinymce.activeEditor) {
      window.tinymce.activeEditor.setMode("readonly");
      window.tinymce.activeEditor.ui.hide();
      setDragging(true);
      // this.setState({
      //   papa: true
      // });
    }
  };

  return (
    <div
      className="flex flex-row-reverse relative h-screen w-full"
      // onClick={() => {
      //   // tinymce.activeEditor.setMode("readonly");
      // }}
    >
      <div className="w-1/2 relative pt-12 overflow-hidden">
        <div
          className="bg-gray-100 shadow top-0 right-0 w-1/2 px-4 top-0 relative flex items-center justify-between h-12"
          style={{ position: "fixed", zIndex: "99999" }}
        ></div>
        {htmlInput && (
          <CodeEditor
            defaultHtml={htmlInput}
            submit={(value) => {
              setHtmlInput("");
              setItems([]);
              // setReactComponent(null);
              setTimeout(function () {
                setHtmlInput(value);
                parseHTMLInput(value);
              }, 20);
            }}
          />
        )}
      </div>
      {/* {this.state.reactComponent} */}
      {/* {reactHtml} */}
      {/* <div dangerouslySetInnerHTML={{ __html: htmlInput }} /> */}

      {/* newsletter body/container style */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            bodyAttributes && bodyAttributes.style
              ? `.newsletter-container, .dragging-component{${bodyAttributes.style.value}}`
              : ""
        }}
      ></style>

      <div
        className="w-1/2 newsletter-container pt-20 px-8 pb-8"
        style={{ height: "100vh", overflowY: "auto" }}
      >
        <div
          className="bg-gray-100 shadow top-0 left-0 w-1/2 px-3 top-0 relative flex items-center justify-between h-12"
          style={{ position: "fixed", zIndex: "99999" }}
        >
          <div className="flex">
            <img
              alt="Letter logo"
              className="h-6 my-auto"
              src="https://app.letter.so/packages/letter-app/lib/static/svg-icons/logo-dark.svg"
            />
            <div
              className="brand text-lg ml-2 my-auto"
              style={{ color: "rgb(45,60,155)" }}
            >
              Letter MJML
            </div>
          </div>
          <form
            name="codepen"
            onSubmit={(e) => {
              e.preventDefault();
              submitCodepen(e);
            }}
            // action="https://codepen.io/pen/define"
            // method="POST"
            // target="_blank"
          >
            <input type="hidden" name="data" />
            <button
              className="flex z-50 left-0 text-sm bottom-0 border border-gray-600 hover:bg-gray-50 text-gray-600 font-medium py-1 px-2 rounded  cursor-pointer bg-transparent flex"
              type="submit"
            >
              {codepenSVG}
              <span className="pl-2 my-auto">Export</span>
            </button>
          </form>
        </div>
        {/* add stylesheet and stuff */}
        {head && (
          <div>
            <div dangerouslySetInnerHTML={{ __html: head[0].outerHTML }} />
          </div>
        )}
        {!parsedHTML && <h1 className="text-xl">Loading</h1>}
        {parsedHTML && (
          <DragDropContext
            className="mx-auto"
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
          >
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {/* <tbody> */}
                  {/* here is where we need to wrap the thing with the original wrapper?
                  - or just store the wrapper in state and wrap at the end
                  
                  */}
                  {items.map((item, index) => (
                    <Draggable
                      key={item.id + "_key" + index}
                      draggableId={item.id + "_id" + index}
                      index={index}
                    >
                      {(provided, snapshot) => {
                        // console.log(item.component);
                        return (
                          <div
                            data-letter_id={item.id}
                            className={`w-full ${
                              snapshot.isDragging ? "dragging-component" : ""
                            }`}
                            // style={{ clear: "both" }}
                            data-letter_section={index}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <div>
                              {recursiveMap(item.component, (child) =>
                                React.cloneElement(child, {
                                  dragging: dragging
                                  // papa: _this.state.papa
                                })
                              )}
                              {/* {React.cloneElement(item.component, {didComplete: true})} */}
                            </div>

                            {/* {item.component} */}
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {/* </tbody> */}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </div>
    </div>
  );
}

export default App;
// Put the thing into the DOM!
// ReactDOM.render(<App />, document.getElementById("root"));

function recursiveMap(children, fn) {
  return React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }

    if (child.props.children) {
      child = React.cloneElement(child, {
        children: recursiveMap(child.props.children, fn)
      });
    }

    return fn(child);
  });
}
